    // Reveal JS
    function reveal() {
            var reveals = document.querySelectorAll(".reveal");
            for (var i = 0; i < reveals.length; i++) {
                var windowHeight = window.innerHeight;
                var elementTop = reveals[i].getBoundingClientRect().top;
                var elementVisible = 150;
                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add("active");
                } else {
                    reveals[i].classList.remove("active");
                }
            }
        }

        window.addEventListener("scroll", reveal);
        reveal();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__info-container').forEach(function (container) {
    Array.from(container.children)
      .filter(child => child.classList.contains('icon_text_block'))
      .forEach(function (el) {
        const prev = el.previousElementSibling;
        if (prev && prev.classList.contains('icon_with_text_wrapper')) {
          prev.appendChild(el);
        } else {
          const wrapper = document.createElement('div');
          wrapper.className = 'icon_with_text_wrapper';

          container.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        }
      });
  });
});


(function () {

  // ─── RECHARGE LOYALTY TIERS ───────────────────────────────────────────────

  const RC_WIDGET_SELECTOR    = 'recharge-subscription-widget';
  const RC_CONTAINER_SELECTOR = '.rc-purchase-option__sub-container';
  const RC_LOYALTY_CLASS      = 'rc-loyalty-tiers';

  // A product can override these via the custom.subscription_tiers metafield,
  // which product.json outputs as window.RC_LOYALTY_TIERS
  const defaultTiers = [
    { order: 'Order #3',  pct: '35%', label: 'OFF',     active: false },
    { order: 'Order #6',  pct: '40%', label: 'OFF',     active: false },
    { order: 'Order #9',  pct: '45%', label: 'OFF',     active: false },
    { order: 'Order #12', pct: '50%', label: 'MAX OFF', active: true  },
  ];
  const getTiers = () => Array.isArray(window.RC_LOYALTY_TIERS) ? window.RC_LOYALTY_TIERS : defaultTiers;

  function buildRCStyles() {
    const style = document.createElement('style');
    style.id = 'rc-loyalty-tiers-style';
    style.textContent = `
    
      .rc-loyalty-tiers { padding: 10px 0 0; margin-top: 2px; border-top: 1px solid #ddd; }
      .rc-loyalty-tiers__title { font-weight: bold; font-size: 13px; margin: 0 0 2px; text-transform: uppercase; }
      .rc-loyalty-tiers__subtitle { font-size: 12px; color: #666; margin: 0 0 10px; }
      .rc-loyalty-tiers__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px; }
      .rc-loyalty-tiers__item { border: 1px solid #ddd; border-radius: 6px; padding: 8px 4px; text-align: center; display: flex; flex-direction: column; gap: 2px; }
      .rc-loyalty-tiers__item--active { border: 1.5px solid #DF202E; }
      .rc-loyalty-tiers__order { font-size: 11px; color: #888; }
      .rc-loyalty-tiers__pct { font-size: 18px; font-weight: bold; color: #DF202E; }
      .rc-loyalty-tiers__off { font-size: 11px; color: #888; }
      .rc-loyalty-tiers__item--active .rc-loyalty-tiers__off { color: #DF202E; font-weight: bold; }
    `;
    return style;
  }

  function buildRCBlock() {
    const block = document.createElement('div');
    block.className = RC_LOYALTY_CLASS;
    block.innerHTML = `
      <div class="rc-loyalty-tiers__header">
        <p class="rc-loyalty-tiers__title">LOYALTY REWARDS</p>
        <p class="rc-loyalty-tiers__subtitle">Your discount unlocks automatically as you subscribe</p>
      </div>
      <div class="rc-loyalty-tiers__grid">
        ${getTiers().map(t => `
          <div class="rc-loyalty-tiers__item ${t.active ? 'rc-loyalty-tiers__item--active' : ''}">
            <span class="rc-loyalty-tiers__order">${t.order}</span>
            <span class="rc-loyalty-tiers__pct">${t.pct}</span>
            <span class="rc-loyalty-tiers__off">${t.label}</span>
          </div>
        `).join('')}
      </div>
    `;
    return block;
  }

  // Rewrites Recharge's own badge / benefit copy so it matches the product's
  // plan discount and top tier. Only runs when the product has the
  // custom.subscription_tiers metafield (window.RC_COPY is set by product.json).
  function applyRCCopy(root) {
    const copy = window.RC_COPY;
    if (!copy) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      let v = n.nodeValue;
      if (copy.max) v = v.replace(/Save up to \d+%/, 'Save up to ' + copy.max + '%');
      if (copy.base) v = v.replace(/\d+% off every order/, copy.base + '% off every order');
      if (v !== n.nodeValue) n.nodeValue = v;
    }
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) applyRCCopy(el.shadowRoot);
    });
  }

  function injectRC(shadowRoot) {
    applyRCCopy(shadowRoot);
    const subContainer = shadowRoot.querySelector(RC_CONTAINER_SELECTOR);
    if (!subContainer) return;
    if (subContainer.querySelector('.' + RC_LOYALTY_CLASS)) return;
    if (!shadowRoot.querySelector('#rc-loyalty-tiers-style')) {
      shadowRoot.appendChild(buildRCStyles());
    }
    subContainer.appendChild(buildRCBlock());
  }

  function watchRCShadow(shadowRoot) {
    injectRC(shadowRoot);
    new MutationObserver(function () {
      injectRC(shadowRoot);
    }).observe(shadowRoot, { childList: true, subtree: true });
  }

  function initRC() {
    const widget = document.querySelector(RC_WIDGET_SELECTOR);
    if (!widget || !widget.shadowRoot) return false;
    watchRCShadow(widget.shadowRoot);
    return true;
  }


  // ─── GORGIAS INPUT PLACEHOLDER ───────────────────────────────────────────

  const GG_WIDGET_SELECTOR = '.gorgias-spq';
  const GG_INPUT_SELECTOR  = '.gorgias-spq-input';
  const GG_PLACEHOLDER     = 'Questions? Get instant answers.';

  function injectGG(shadowRoot) {
    const input = shadowRoot.querySelector(GG_INPUT_SELECTOR);
    if (!input) return;
    if (input.getAttribute('placeholder') === GG_PLACEHOLDER) return;
    input.setAttribute('placeholder', GG_PLACEHOLDER);
  }

  function watchGGShadow(shadowRoot) {
    injectGG(shadowRoot);
    const observer = new MutationObserver(function () {
      injectGG(shadowRoot);
      // once set and stable, disconnect
      const input = shadowRoot.querySelector(GG_INPUT_SELECTOR);
      if (input && input.getAttribute('placeholder') === GG_PLACEHOLDER) {
        observer.disconnect();
      }
    });
    observer.observe(shadowRoot, { childList: true, subtree: true, attributes: true });
  }

  function initGG() {
    const widget = document.querySelector(GG_WIDGET_SELECTOR);
    if (!widget || !widget.shadowRoot) return false;
    watchGGShadow(widget.shadowRoot);
    return true;
  }



  function bootAll() {
    const rcDone = initRC();
    const ggDone = initGG();

    if (!rcDone || !ggDone) {
      const domObserver = new MutationObserver(function () {
        const allDone = (!rcDone ? initRC() : true) && (!ggDone ? initGG() : true);
        if (allDone) domObserver.disconnect();
      });
      domObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

})();


const run = () => {
  const host = document.querySelector('recharge-subscription-widget');
  if (!host) return;

  const widgetRoot = host.shadowRoot;
  if (!widgetRoot) return;

  const benefits = widgetRoot.querySelector('rc-benefits');
  const benefitsRoot = benefits?.shadowRoot;
  if (!benefitsRoot) return;

  const items = benefitsRoot.querySelectorAll('li');

  const svgs = [
    `<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="1.22 1.22 21.8 21.8">   <g transform="translate(24 0) scale(-1 1)">     <path d="M0 0h24v24H0z" fill="none"></path>     <g fill="none">       <path d="m11.878 22.02l-9.9-9.899l9.9-9.9l9.192.708l.707 9.192z"></path>       <path d="M14 7.17A2 2 0 1 1 16.828 10A2 2 0 0 1 14 7.17"></path>       <path stroke="currentColor" stroke-width="2" d="m11.878 22.02l-9.9-9.899l9.9-9.9l9.192.708l.707 9.192z"></path>       <path stroke="currentColor" stroke-width="2" d="M14 7.17A2 2 0 1 1 16.828 10A2 2 0 0 1 14 7.17Z"></path>     </g>   </g> </svg>`,
    `<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2 6 20 12.5">   <path d="M3 7h11v8H3V7Z" stroke="currentColor" stroke-width="2"></path>   <path d="M14 9h4l3 3v3h-7V9Z" stroke="currentColor" stroke-width="2"></path>   <circle cx="7" cy="17" r="1.5" fill="currentColor"></circle>   <circle cx="17" cy="17" r="1.5" fill="currentColor"></circle> </svg>`,
    `<svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="2.4 0.9 9.2 12.2">   <rect x="3" y="1.5" width="8" height="11" rx="1.2" stroke="currentColor" stroke-width="1.2"></rect>   <path d="M5 4.5H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path>   <circle cx="7" cy="10.5" r="0.7" fill="currentColor"></circle> </svg>`
  ];

  items.forEach((li, i) => {
    if (li.dataset.iconAdded) return;

    li.style.listStyle = "none";
    li.style.paddingRight = "0px";
    li.style.display = "flex";
    li.style.alignItems = "center";

    const style = benefitsRoot.__iconStyle;
    if (!style) {
      const s = document.createElement('style');
      s.textContent = `
        li::before {
          content: none !important;
          display: none !important;
        }
        li {
          margin-bottom: 5px !important;
        }
        ul {
          padding-right: 0 !important;
          margin-right: 0 !important;
        }
      `;
      benefitsRoot.appendChild(s);
      benefitsRoot.__iconStyle = true;
    }

    const iconWrap = document.createElement("span");
    iconWrap.style.display = "inline-flex";
    iconWrap.style.marginRight = "9px";
    iconWrap.style.marginLeft = "6px";
    iconWrap.innerHTML = svgs[i] || svgs[0];

    li.prepend(iconWrap);

    li.dataset.iconAdded = "true";
  });
};

setTimeout(run, 1000);
setTimeout(run, 2500);
setTimeout(run, 5000);

const observer = new MutationObserver(() => {
  run();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

setInterval(run, 2000);